<template>
  <v-container fluid class="pa-0">
    <!-- 顶部背景 -->
    <div class="edit-hero">
      <div class="edit-pattern"></div>
      <v-container class="fill-height">
        <v-row align="center" justify="center">
          <v-col cols="12" class="text-center">
            <div class="edit-hero-content">
              <v-icon icon="mdi-feather" size="64" color="pink-lighten-3" class="mb-6"></v-icon>
              <h1 class="text-h2 font-weight-bold mb-4 dream-text">
                {{ isEditing ? '编辑文章' : '创作新文' }}
              </h1>
              <p class="text-h6 subtitle-text">
                {{ isEditing ? '让文字焕发新的光彩' : '用文字记录美好时光' }}
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- 编辑区域 -->
    <v-container class="mt-n16">
      <v-row>
        <v-col cols="12" lg="8" offset-lg="2">
          <v-card class="editor-card" elevation="0">
            <v-card-text class="pa-8">
              <!-- 返回按钮 -->
              <v-btn
                :to="{ name: 'Home' }"
                color="pink-lighten-3"
                variant="text"
                class="mb-8 back-btn"
                prepend-icon="mdi-arrow-left"
              >
                <span class="text-pink-darken-1">返回首页</span>
              </v-btn>

              <!-- 编辑表单 -->
              <v-form @submit.prevent="savePost" class="article-form">
                <!-- 标题输入 -->
                <div class="title-section mb-8">
                  <label class="text-subtitle-1 font-weight-medium mb-2 d-block text-pink-darken-1">文章标题</label>
                  <v-text-field
                    v-model="post.title"
                    variant="outlined"
                    density="comfortable"
                    placeholder="在这里写下您的标题..."
                    :rules="[v => !!v || '标题不能为空']"
                    required
                    class="title-input"
                    color="pink-lighten-3"
                    bg-color="pink-lighten-5"
                    hide-details="auto"
                  ></v-text-field>
                </div>

                <!-- 内容输入 -->
                <div class="content-section mb-8">
                  <label class="text-subtitle-1 font-weight-medium mb-2 d-block text-pink-darken-1">文章内容</label>
                  <v-textarea
                    v-model="post.content"
                    variant="outlined"
                    rows="15"
                    placeholder="让思维在这里流淌..."
                    :rules="[v => !!v || '内容不能为空']"
                    required
                    class="content-input"
                    color="pink-lighten-3"
                    bg-color="pink-lighten-5"
                    hide-details="auto"
                  ></v-textarea>
                </div>

                <!-- 分类选择 -->
                <div class="category-section mb-8">
                  <label class="text-subtitle-1 font-weight-medium mb-2 d-block text-pink-darken-1">文章分类</label>
                  <v-chip-group
                    v-model="selectedCategory"
                    selected-class="pink-lighten-4"
                    class="category-chips"
                  >
                    <v-chip
                      v-for="category in categories"
                      :key="category"
                      filter
                      variant="elevated"
                      class="ma-2 category-chip"
                      color="pink-lighten-5"
                    >
                      <span class="text-pink-darken-1">{{ category }}</span>
                    </v-chip>
                  </v-chip-group>
                </div>

                <v-divider class="mb-8"></v-divider>

                <!-- 操作按钮 -->
                <div class="d-flex justify-end">
                  <v-btn
                    color="grey-lighten-1"
                    variant="text"
                    class="mr-4"
                    size="large"
                    @click="$router.push({ name: 'Home' })"
                  >
                    取消
                  </v-btn>
                  <v-btn
                    type="submit"
                    color="pink-lighten-3"
                    size="large"
                    :loading="saving"
                    :disabled="!post.title || !post.content"
                    elevation="0"
                    class="px-8 publish-btn"
                  >
                    <span class="text-pink-darken-1">{{ isEditing ? '保存修改' : '发布文章' }}</span>
                  </v-btn>
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'PostEditPage',
  data() {
    return {
      post: {
        title: '',
        content: ''
      },
      saving: false,
      selectedCategory: 0,
      categories: ['技术', '生活', '随笔', '前端', '后端', 'AI']
    }
  },
  computed: {
    isEditing() {
      return !!this.$route.params.id
    }
  },
  mounted() {
    if (this.$route.params.id) {
      // 加载文章数据的逻辑
    }
  },
  methods: {
    async savePost() {
      this.saving = true
      try {
        // 保存文章的逻辑
        await new Promise(resolve => setTimeout(resolve, 1000))
        this.$router.push({ name: 'Home' })
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.edit-hero {
  position: relative;
  min-height: 400px;
  background: linear-gradient(135deg, #fce4ec 0%, #f3e5f5 50%, #e1f5fe 100%);
  display: flex;
  align-items: center;
  overflow: hidden;
}

.edit-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(circle at 1px 1px, rgba(255, 182, 193, 0.15) 1px, transparent 0);
  background-size: 40px 40px;
  opacity: 0.5;
}

.edit-hero-content {
  position: relative;
  z-index: 1;
}

.dream-text {
  background: linear-gradient(45deg, #e91e63, #9c27b0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.subtitle-text {
  color: #9c27b0;
  opacity: 0.8;
}

.editor-card {
  background: white;
  border-radius: 24px;
  box-shadow: 0 4px 24px rgba(233, 30, 99, 0.1);
  border: 1px solid rgba(233, 30, 99, 0.1);
}

.back-btn {
  transition: all 0.3s ease;
}

.back-btn:hover {
  transform: translateX(-4px);
}

.title-input :deep(.v-field__input),
.content-input :deep(.v-field__input) {
  font-size: 1.1rem;
  line-height: 1.8;
}

.title-input :deep(.v-field),
.content-input :deep(.v-field) {
  border-radius: 12px;
  transition: all 0.3s ease;
  border: 1px solid rgba(233, 30, 99, 0.1);
}

.title-input :deep(.v-field:hover),
.content-input :deep(.v-field:hover) {
  border-color: rgba(233, 30, 99, 0.2);
  background: white;
}

.title-input :deep(.v-field--focused),
.content-input :deep(.v-field--focused) {
  border-color: rgba(233, 30, 99, 0.3);
  background: white;
  box-shadow: 0 0 0 4px rgba(233, 30, 99, 0.1);
}

.category-chip {
  transition: all 0.3s ease;
  border: 1px solid rgba(233, 30, 99, 0.1) !important;
}

.category-chip:hover {
  transform: translateY(-2px);
  background: linear-gradient(135deg, #fce4ec, #f3e5f5) !important;
  border-color: rgba(233, 30, 99, 0.2) !important;
}

.publish-btn {
  transition: all 0.3s ease;
  border: 2px solid rgba(233, 30, 99, 0.1);
}

.publish-btn:hover {
  transform: translateY(-2px);
  background: linear-gradient(135deg, #fce4ec, #f3e5f5) !important;
  border-color: rgba(233, 30, 99, 0.2);
}
</style> 